export default {
  ownedByPartnerId: null,
  name: "",
  description: "",
  deploymentId: "",
  allowedEventTypes: [],
  liveCommentatorSupport: 0,
  keepVideosForMonths: 0,
  allowedMasterStreamSave: false,
  monthlyTiiviiHours: 0,
  allowedProductionTypes: [],
  tiiviiOttConfig: {
    enabled: false,
    webhookUrl: '',
    nimbleConfigUrl: ''
  }
}
